import { AvailableChildrenType, SugarElementInfo } from "../../Suggester/SugarElementInfo";

export const bold: SugarElementInfo = { name: "bold", availableChildren: { type: AvailableChildrenType.Any } };
